import { Company } from "../../../model/Company";
import { ContentContainer, FlexRow, ProfileTextContainerLargeText, ReadOnlyContainer } from "../../../styles/backend/container";
import { BackendGridContainer, BackendGridItem } from "../../../styles/backend/grid";
import { ReadOnlyEditor } from "../../global/ReadOnlyEditor";

interface Props {
    company: Company | undefined;
    largeHeadline?: boolean;
}

export const CompanyDescriptionRead = ({ company, largeHeadline = false }: Props) => {
    return (
        company?.description != null && company?.description?.length > 0 ?
            <BackendGridContainer className='container-margin'>
                <BackendGridItem span={12}>
                    <ContentContainer cols={1} largeHeadline={largeHeadline}>
                        <ProfileTextContainerLargeText>
                            <div>
                                <div className='container-headline'>
                                    <strong>{company?.name} stellt sich vor</strong>
                                </div>
                                <ReadOnlyContainer>
                                    <FlexRow>
                                        {company?.description != null && company?.description.length > 20 &&
                                            <ReadOnlyEditor storedStateRaw={company.description} />
                                        }
                                    </FlexRow>
                                </ReadOnlyContainer>
                            </div>
                        </ProfileTextContainerLargeText>
                    </ContentContainer>
                </BackendGridItem>
            </BackendGridContainer>
            : <></>
    )
}